import { createContext } from "react";

const RouterContext = createContext({
    setRoute:()=>{}
})

export default RouterContext;